import { FormFieldType, SOCIAL_SHARING_CONSENT_KEY } from "@/services/bedrock";

const REVIEW_QUESTION_TYPES: FormFieldType[] = ["star", "nps", "ten_point"];

interface FieldLike {
  fieldKey?: string;
  fieldType?: string;
  active?: boolean;
}

export const needsConsentQuestion = (fields: FieldLike[] = []): boolean => {
  const active = fields.filter(field => field.active !== false);
  return (
    active.some(field => REVIEW_QUESTION_TYPES.includes(field.fieldType as FormFieldType)) &&
    !active.some(field => field.fieldKey === SOCIAL_SHARING_CONSENT_KEY)
  );
};

export const CONSENT_QUESTION = {
  fieldKey: SOCIAL_SHARING_CONSENT_KEY,
  fieldType: "boolean",
  title: "I consent to having my review shared publicly, including on social media.",
  required: false,
  active: true,
} as const;
